import React from 'react'

const Users = () => {
  return (
    <div>
      User
    </div>
  )
}

export default Users
